import React, { Fragment, useEffect, useRef } from 'react';
import './BingeMatesPage.css';
import heroImage from '../../images/bingemates/BingeMates_1280.png';
import chatImage from '../../images/bingemates/BingeMates_640.png';
import appletv from '../../images/bingemates/platforms/appletv.png';
import crunchyroll from '../../images/bingemates/platforms/crunchyroll.png';
import disneyplus from '../../images/bingemates/platforms/disneyplus.png';
import espnplus from '../../images/bingemates/platforms/espnplus.png';
import hotstar from '../../images/bingemates/platforms/hotstar.png';
import hulu from '../../images/bingemates/platforms/hulu.png';
import max from '../../images/bingemates/platforms/max.png';
import netflix from '../../images/bingemates/platforms/netflix.png';
import paramountplus from '../../images/bingemates/platforms/paramountplus.png';
import peacock from '../../images/bingemates/platforms/peacock.png';
import plutotv from '../../images/bingemates/platforms/plutotv.png';
import primevideo from '../../images/bingemates/platforms/primevideo.png';
import spotify from '../../images/bingemates/platforms/spotify.png';
import starplus from '../../images/bingemates/platforms/starplus.png';
import tubi from '../../images/bingemates/platforms/tubi.png';
import youtube from '../../images/bingemates/platforms/youtube.png';

const CHROME_STORE_URL =
  'https://chromewebstore.google.com/detail/bingemates-watch-together/ohkcifkdgcdmpnimkjamlijggmdlpnom';

const PLATFORMS = [
  { name: 'Netflix', img: netflix },
  { name: 'YouTube', img: youtube },
  { name: 'Disney+', img: disneyplus },
  { name: 'Hulu', img: hulu },
  { name: 'Prime Video', img: primevideo },
  { name: 'Max', img: max },
  { name: 'Paramount+', img: paramountplus },
  { name: 'Peacock', img: peacock },
  { name: 'Apple TV+', img: appletv },
  { name: 'Crunchyroll', img: crunchyroll },
  { name: 'Tubi', img: tubi },
  { name: 'Pluto TV', img: plutotv },
  { name: 'ESPN+', img: espnplus },
  { name: 'Hotstar', img: hotstar },
  { name: 'Star+', img: starplus },
  { name: 'Spotify', img: spotify },
];

const FEATURES = [
  {
    title: 'Real-Time Video Sync',
    desc: 'Play, pause, and seek are instantly mirrored to every participant. No one falls behind or spoils the scene.',
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <polygon points="5 3 19 12 5 21 5 3" />
      </svg>
    ),
  },
  {
    title: 'Live Chat Rail',
    desc: 'A collapsible chat panel overlays the video with text, emoji reactions, and GIFs — plus a blinking dot for unread messages.',
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" />
      </svg>
    ),
  },
  {
    title: 'Voice Chat',
    desc: 'One-click in-room voice channel powered by WebRTC (PeerJS). No third-party app required.',
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M12 1a3 3 0 0 0-3 3v8a3 3 0 0 0 6 0V4a3 3 0 0 0-3-3z" />
        <path d="M19 10v2a7 7 0 0 1-14 0v-2" />
        <line x1="12" y1="19" x2="12" y2="23" />
      </svg>
    ),
  },
  {
    title: 'Video Chat',
    desc: 'Optional face-cam grid overlay so you can see everyone’s reactions. Up to 6 on stage, 20 total participants.',
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <polygon points="23 7 16 12 23 17 23 7" />
        <rect x="1" y="5" width="15" height="14" rx="2" ry="2" />
      </svg>
    ),
  },
  {
    title: 'Mood Themes',
    desc: 'Six hand-crafted themes — Cinema, Horror, Sports, Anime, Late Night, and Documentary — the host can switch anytime.',
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <circle cx="13.5" cy="6.5" r=".5" fill="currentColor" />
        <circle cx="17.5" cy="10.5" r=".5" fill="currentColor" />
        <circle cx="8.5" cy="7.5" r=".5" fill="currentColor" />
        <circle cx="6.5" cy="12.5" r=".5" fill="currentColor" />
        <path d="M12 2C6.5 2 2 6.5 2 12s4.5 10 10 10c.926 0 1.648-.746 1.648-1.688 0-.437-.18-.835-.437-1.125-.29-.289-.438-.652-.438-1.125a1.64 1.64 0 0 1 1.668-1.668h1.996c3.051 0 5.563-2.512 5.563-5.563C22 6.012 17.5 2 12 2z" />
      </svg>
    ),
  },
  {
    title: 'Room System',
    desc: 'Create a room in one click and share the code. Friends join by entering it — no sign-in required.',
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <rect x="3" y="11" width="18" height="11" rx="2" ry="2" />
        <path d="M7 11V7a5 5 0 0 1 10 0v4" />
      </svg>
    ),
  },
  {
    title: 'Discover Tab',
    desc: 'Curated watch rituals and ideas like “First Episode Club”, “Silent Watch”, and “Director’s Commentary Night”.',
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <circle cx="12" cy="12" r="10" />
        <polygon points="16.24 7.76 14.12 14.12 7.76 16.24 9.88 9.88 16.24 7.76" />
      </svg>
    ),
  },
  {
    title: '18 Streaming Platforms',
    desc: 'Host a watch party on Netflix, YouTube, Disney+, Prime Video, Max and more — all the platforms you already love.',
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <rect x="2" y="3" width="20" height="14" rx="2" ry="2" />
        <line x1="8" y1="21" x2="16" y2="21" />
        <line x1="12" y1="17" x2="12" y2="21" />
      </svg>
    ),
  },
  {
    title: 'Up to 20 Participants',
    desc: 'Bring the whole crew. Host watch parties with up to 20 people and 6 simultaneous video-chat speakers.',
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" />
        <circle cx="9" cy="7" r="4" />
        <path d="M23 21v-2a4 4 0 0 0-3-3.87" />
        <path d="M16 3.13a4 4 0 0 1 0 7.75" />
      </svg>
    ),
  },
];

const STEPS = [
  {
    title: 'Install',
    desc: 'Add BingeMates to Chrome in one click. Free, no sign-up.',
  },
  {
    title: 'Create or Join',
    desc: 'Start a room and share your 6-digit code, or enter a friend’s code to join their party.',
  },
  {
    title: 'Watch',
    desc: 'Hit play. BingeMates keeps everyone in sync automatically — chat, react, and talk while you watch.',
  },
];

const THEMES = [
  { name: 'Cinema', from: '#ff7a59', to: '#ffd166', mood: 'Classic amber warmth' },
  { name: 'Horror', from: '#ff3b6b', to: '#6d28d9', mood: 'Deep crimson energy' },
  { name: 'Sports', from: '#4ade80', to: '#ffb088', mood: 'Electric green' },
  { name: 'Anime', from: '#f0abfc', to: '#6d28d9', mood: 'Soft lilac and pink' },
  {
    name: 'Late Night',
    from: '#ff6a3d',
    to: '#ffb088',
    mood: 'Warm ember orange',
    isDefault: true,
  },
  { name: 'Documentary', from: '#7dd3fc', to: '#ffd1a3', mood: 'Sky blue calm' },
];

const USE_CASES = [
  {
    title: 'Long-Distance Movie Nights',
    desc: 'Keep date night alive across time zones. Press play together no matter how many miles apart.',
    emoji: '💞',
  },
  {
    title: 'Friends & Family',
    desc: 'Gather the group for a film, a finale, or a guilty-pleasure rewatch — all perfectly in sync.',
    emoji: '🍿',
  },
  {
    title: 'Anime & K-Drama Clubs',
    desc: 'Run a weekly watch club on Crunchyroll or Netflix and react to every twist in real time.',
    emoji: '🌸',
  },
  {
    title: 'Sports Watch-Alongs',
    desc: 'Cheer the big game together on ESPN+ or Hotstar with live voice chat for every goal.',
    emoji: '🏆',
  },
  {
    title: 'Remote Team Socials',
    desc: 'Host a casual co-watch for your distributed team — no extra meeting tools required.',
    emoji: '🧑‍💻',
  },
  {
    title: 'Music Listening Parties',
    desc: 'Drop a Spotify session and vibe to a new album together with friends, in sync.',
    emoji: '🎧',
  },
];

const ShieldIcon = (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
  </svg>
);
const LockIcon = (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <rect x="3" y="11" width="18" height="11" rx="2" ry="2" />
    <path d="M7 11V7a5 5 0 0 1 10 0v4" />
  </svg>
);
const NoAccountIcon = (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
    <circle cx="9" cy="7" r="4" />
    <line x1="17" y1="8" x2="23" y2="14" />
    <line x1="23" y1="8" x2="17" y2="14" />
  </svg>
);
const TrashClockIcon = (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <polyline points="3 6 5 6 21 6" />
    <path d="M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6" />
    <path d="M12 11v4" />
    <path d="M10 13h4" />
  </svg>
);
const EyeOffIcon = (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19" />
    <path d="M1 1l22 22" />
  </svg>
);
const DeviceIcon = (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <rect x="2" y="3" width="20" height="14" rx="2" ry="2" />
    <line x1="8" y1="21" x2="16" y2="21" />
    <line x1="12" y1="17" x2="12" y2="21" />
  </svg>
);

const SECURITY = [
  {
    title: 'No Account Required',
    desc: 'Jump in with just a display name. We never ask for an email, your real name, or a sign-up.',
    icon: NoAccountIcon,
  },
  {
    title: 'Encrypted in Transit',
    desc: 'Every byte travels over HTTPS/TLS. Voice and video run peer-to-peer through WebRTC.',
    icon: LockIcon,
  },
  {
    title: 'Row-Level Security',
    desc: 'Room data is isolated with database Row Level Security, so only your room can read it.',
    icon: ShieldIcon,
  },
  {
    title: 'Rooms Auto-Delete',
    desc: 'Rooms and chat history are automatically erased 24 hours after creation. Nothing lingers.',
    icon: TrashClockIcon,
  },
  {
    title: 'Zero Tracking',
    desc: 'We never sell your data, share it with advertisers, or follow you across other websites.',
    icon: EyeOffIcon,
  },
  {
    title: 'Manifest V3, Minimal Access',
    desc: 'Built on Chrome’s modern, privacy-first MV3 platform with only the permissions it needs.',
    icon: DeviceIcon,
  },
];

const NEVER_COLLECT = [
  'Email addresses',
  'Real names',
  'Browsing history',
  'Viewing preferences',
  'Location data',
  'Device identifiers',
];

const FAQS = [
  {
    q: 'Is BingeMates really free?',
    a: 'Yes — BingeMates is 100% free with no subscription, no trial, and no account required to get started.',
  },
  {
    q: 'Do my friends need to create an account?',
    a: 'No. Just share your room code and they join instantly by entering it. A display name is all anyone needs.',
  },
  {
    q: 'Does everyone need their own streaming subscription?',
    a: 'Yes. BingeMates syncs playback — it doesn’t stream the content itself. Each participant watches on their own account, perfectly in sync.',
  },
  {
    q: 'Which browsers are supported?',
    a: 'Any Chromium-based browser, including Chrome, Brave, Edge, and Arc.',
  },
  {
    q: 'How many people can join one room?',
    a: 'Up to 20 participants per room, with up to 6 people on the video-chat stage at the same time.',
  },
  {
    q: 'Is my data private and secure?',
    a: 'Absolutely. Data is encrypted in transit with HTTPS/TLS, protected by database Row Level Security, and rooms auto-delete after 24 hours. We never sell or share your data.',
  },
  {
    q: 'Are my chat messages stored?',
    a: 'Chat lives only during the session and is deleted when the room expires. Anonymous usage stats stay local in your browser and can be cleared anytime.',
  },
  {
    q: 'Is BingeMates a free alternative to Teleparty (Netflix Party)?',
    a: 'Yes. BingeMates is a free watch party extension and a strong alternative to Teleparty and Netflix Party. It syncs 18 streaming platforms — not just Netflix — and adds built-in voice and video chat at no cost, with no account required.',
  },
  {
    q: 'Can I watch Netflix, Disney+, or YouTube together with friends online?',
    a: 'Yes. Install BingeMates, create a room, and share the code. Everyone presses play and watches Netflix, Disney+, YouTube, Prime Video, Max and more in perfect sync, with live chat and voice.',
  },
  {
    q: 'How do I host a virtual movie night with friends?',
    a: 'Add BingeMates to Chrome, open your movie on any supported platform, create a room, and send the room code to friends. When everyone joins, playback stays synced so your virtual movie night feels like you are all in the same room.',
  },
];

const ChromeIcon = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    <circle cx="12" cy="12" r="10" />
    <circle cx="12" cy="12" r="4" />
    <line x1="21.17" y1="8" x2="12" y2="8" />
    <line x1="3.95" y1="6.06" x2="8.54" y2="14" />
    <line x1="10.88" y1="21.94" x2="15.46" y2="14" />
  </svg>
);

const BingeMatesPage = () => {
  const rootRef = useRef(null);

  // SEO + AEO: title, meta tags, canonical, and structured data (no helmet in this project)
  useEffect(() => {
    const origin = window.location.origin;
    const pageUrl = `${origin}/bingemates`;
    const ogImage = `${origin}${heroImage}`;
    const description =
      'BingeMates is a free Chrome extension for watch parties — sync Netflix, YouTube, Disney+, Prime Video, Max and 13 more streaming platforms to watch movies and shows together online with real-time chat, voice, and video. A free Teleparty (Netflix Party) alternative, no account required.';

    const prevTitle = document.title;
    document.title =
      'BingeMates — Free Watch Party Extension to Watch Netflix & Disney+ Together | Bogin Tech';

    const managed = [];

    const upsertMeta = (attr, key, content) => {
      const selector = `meta[${attr}="${key}"]`;
      let el = document.head.querySelector(selector);
      const existed = !!el;
      const prev = existed ? el.getAttribute('content') : null;
      if (!el) {
        el = document.createElement('meta');
        el.setAttribute(attr, key);
        document.head.appendChild(el);
      }
      el.setAttribute('content', content);
      managed.push({ el, existed, prev, attr: 'content' });
    };

    const upsertLink = (rel, href) => {
      let el = document.head.querySelector(`link[rel="${rel}"]`);
      const existed = !!el;
      const prev = existed ? el.getAttribute('href') : null;
      if (!el) {
        el = document.createElement('link');
        el.setAttribute('rel', rel);
        document.head.appendChild(el);
      }
      el.setAttribute('href', href);
      managed.push({ el, existed, prev, attr: 'href' });
    };

    upsertMeta('name', 'description', description);
    upsertMeta(
      'name',
      'keywords',
      'watch party, watch party extension, watch Netflix together, Netflix Party, Teleparty alternative, watch Disney Plus together, watch YouTube together, sync video, virtual movie night, watch movies with friends online, long distance movie night, co-watching, group watch, BingeMates'
    );
    upsertMeta('name', 'robots', 'index, follow, max-image-preview:large, max-snippet:-1');
    upsertMeta('name', 'author', 'Bogin Tech');
    upsertMeta('name', 'application-name', 'BingeMates');
    upsertMeta('name', 'theme-color', '#0c0820');

    // Open Graph
    upsertMeta('property', 'og:type', 'website');
    upsertMeta('property', 'og:site_name', 'BingeMates by Bogin Tech');
    upsertMeta('property', 'og:title', 'BingeMates — Watch Together, From Anywhere');
    upsertMeta('property', 'og:description', description);
    upsertMeta('property', 'og:url', pageUrl);
    upsertMeta('property', 'og:image', ogImage);
    upsertMeta(
      'property',
      'og:image:alt',
      'BingeMates watch party interface with synced video and live chat'
    );

    // Twitter
    upsertMeta('name', 'twitter:card', 'summary_large_image');
    upsertMeta('name', 'twitter:title', 'BingeMates — Watch Together, From Anywhere');
    upsertMeta('name', 'twitter:description', description);
    upsertMeta('name', 'twitter:image', ogImage);

    upsertLink('canonical', pageUrl);

    // ---- Structured data (JSON-LD) for rich results + answer engines ----
    const jsonLd = {
      '@context': 'https://schema.org',
      '@graph': [
        {
          '@type': 'SoftwareApplication',
          name: 'BingeMates — Watch Together',
          operatingSystem: 'Chrome, Brave, Microsoft Edge, Arc (Chromium browsers)',
          applicationCategory: 'BrowserApplication',
          applicationSubCategory: 'Watch Party Extension',
          description,
          url: pageUrl,
          downloadUrl: CHROME_STORE_URL,
          installUrl: CHROME_STORE_URL,
          softwareVersion: '1.0.7',
          image: ogImage,
          featureList: [
            'Real-time video sync across 18 streaming platforms',
            'Live text chat with emoji and GIF reactions',
            'In-room voice chat (WebRTC)',
            'Optional video / face-cam chat',
            'Rooms for up to 20 participants',
            'No account or sign-up required',
          ],
          offers: {
            '@type': 'Offer',
            price: '0',
            priceCurrency: 'USD',
            availability: 'https://schema.org/InStock',
          },
          publisher: {
            '@type': 'Organization',
            name: 'Bogin Tech',
            url: origin,
          },
        },
        {
          '@type': 'FAQPage',
          mainEntity: FAQS.map((item) => ({
            '@type': 'Question',
            name: item.q,
            acceptedAnswer: { '@type': 'Answer', text: item.a },
          })),
        },
        {
          '@type': 'BreadcrumbList',
          itemListElement: [
            { '@type': 'ListItem', position: 1, name: 'Home', item: `${origin}/` },
            { '@type': 'ListItem', position: 2, name: 'BingeMates', item: pageUrl },
          ],
        },
      ],
    };

    const ld = document.createElement('script');
    ld.type = 'application/ld+json';
    ld.text = JSON.stringify(jsonLd);
    ld.setAttribute('data-bm-jsonld', 'true');
    document.head.appendChild(ld);

    return () => {
      document.title = prevTitle;
      managed.forEach(({ el, existed, prev, attr }) => {
        if (existed) {
          if (prev !== null) el.setAttribute(attr, prev);
        } else {
          el.remove();
        }
      });
      ld.remove();
    };
  }, []);

  // Intersection Observer entrance animations
  useEffect(() => {
    const root = rootRef.current;
    if (!root) return;
    const items = root.querySelectorAll('.bm-reveal');

    if (!('IntersectionObserver' in window)) {
      items.forEach((el) => el.classList.add('bm-in'));
      return;
    }

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('bm-in');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.15, rootMargin: '0px 0px -60px 0px' }
    );

    items.forEach((el) => observer.observe(el));
    return () => observer.disconnect();
  }, []);

  return (
    <Fragment>
      <div className="bm-page" ref={rootRef}>
        <div className="bm-orbs" aria-hidden="true">
          <span className="bm-orb bm-orb--orange" />
          <span className="bm-orb bm-orb--purple" />
          <span className="bm-orb bm-orb--peach" />
        </div>

        <div className="bm-shell">
          {/* ===================== HERO ===================== */}
          <header className="bm-hero">
            <div className="bm-container">
              <a className="bm-brand bm-reveal" href="#top" aria-label="BingeMates home">
                <span className="bm-brand-mark" aria-hidden="true">
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <polygon points="5 3 19 12 5 21 5 3" />
                  </svg>
                </span>
                <span className="bm-brand-name">
                  Binge<span className="bm-gradient-text">Mates</span>
                </span>
              </a>
              <div className="bm-hero-grid">
                <div className="bm-reveal">
                  <span className="bm-badge">
                    <span className="bm-badge-dot" />
                    Free Chrome Extension · v1.0.7
                  </span>
                  <h1>
                    Watch Together,
                    <br />
                    <span className="bm-gradient-text">From Anywhere</span>
                  </h1>
                  <p className="bm-hero-sub">
                    Sync Netflix, YouTube, Disney+ and 15 more platforms with
                    friends — real-time chat, voice, and video, right in your
                    browser.
                  </p>
                  <div className="bm-hero-actions">
                    <a
                      className="bm-btn bm-btn--primary bm-btn--lg"
                      href={CHROME_STORE_URL}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <ChromeIcon />
                      Add to Chrome — It’s Free
                    </a>
                    <a className="bm-btn bm-btn--ghost" href="#how-it-works">
                      See how it works ↓
                    </a>
                  </div>
                  <ul className="bm-hero-trust">
                    <li>✓ No account needed</li>
                    <li>✓ No tracking</li>
                    <li>✓ Free forever</li>
                  </ul>
                </div>

                <div className="bm-hero-visual bm-reveal">
                  <img
                    className="bm-hero-img"
                    src={heroImage}
                    alt="BingeMates watch party interface showing synced video playback with friends"
                    width="1200"
                    height="750"
                    loading="eager"
                  />
                  <img
                    className="bm-hero-chat"
                    src={chatImage}
                    alt="BingeMates live chat rail overlay with messages and emoji reactions"
                    width="600"
                    height="480"
                    loading="lazy"
                  />
                </div>
              </div>
            </div>
          </header>

          {/* ===================== WHAT IS / AEO INTRO ===================== */}
          <section className="bm-section" aria-labelledby="bm-intro-title">
            <div className="bm-container bm-container--narrow">
              <div className="bm-section-head bm-reveal">
                <span className="bm-eyebrow">What is BingeMates?</span>
                <h2 className="bm-section-title" id="bm-intro-title">
                  A free watch party extension for movies, shows, and sports
                </h2>
                <p className="bm-section-sub">
                  BingeMates is a free Chrome extension for hosting online watch
                  parties. It synchronizes video playback across 18 streaming
                  platforms — including Netflix, YouTube, Disney+, Prime Video and
                  Max — so you and your friends can watch movies and shows
                  together in real time, complete with live chat, voice, and
                  video. There is no account, no subscription, and no setup:
                  install it, create a room, share the code, and press play. As a
                  free Teleparty and Netflix Party alternative, BingeMates works
                  across far more platforms and adds built-in voice and video
                  chat so every watch party feels like you are in the same room.
                </p>
              </div>
            </div>
          </section>

          {/* ===================== PLATFORMS ===================== */}
          <section className="bm-section" aria-labelledby="bm-platforms-title">
            <div className="bm-container">
              <div className="bm-section-head bm-reveal">
                <span className="bm-eyebrow">Supported platforms</span>
                <h2 className="bm-section-title" id="bm-platforms-title">
                  Works on every platform you love
                </h2>
              </div>
              <div className="bm-platform-grid bm-reveal">
                {PLATFORMS.map((p) => (
                  <div className="bm-platform-tile" key={p.name} title={p.name}>
                    <img
                      src={p.img}
                      alt={`${p.name} logo`}
                      width="256"
                      height="256"
                      loading="lazy"
                    />
                  </div>
                ))}
              </div>
              <p className="bm-platform-caption bm-reveal">
                18 streaming platforms and counting
              </p>
            </div>
          </section>

          {/* ===================== FEATURES ===================== */}
          <section className="bm-section" aria-labelledby="bm-features-title">
            <div className="bm-container">
              <div className="bm-section-head bm-reveal">
                <span className="bm-eyebrow">Features</span>
                <h2 className="bm-section-title" id="bm-features-title">
                  Everything you need for the perfect watch party
                </h2>
                <p className="bm-section-sub">
                  One extension brings sync, chat, voice, video, and vibes —
                  with no extra apps or accounts.
                </p>
              </div>
              <div className="bm-feature-grid">
                {FEATURES.map((f) => (
                  <article className="bm-card bm-reveal" key={f.title}>
                    <span className="bm-feature-icon">{f.icon}</span>
                    <h3>{f.title}</h3>
                    <p>{f.desc}</p>
                  </article>
                ))}
              </div>
            </div>
          </section>

          {/* ===================== HOW IT WORKS ===================== */}
          <section
            className="bm-section"
            id="how-it-works"
            aria-labelledby="bm-how-title"
          >
            <div className="bm-container">
              <div className="bm-section-head bm-reveal">
                <span className="bm-eyebrow">How it works</span>
                <h2 className="bm-section-title" id="bm-how-title">
                  Up and running in three steps
                </h2>
              </div>
              <div className="bm-steps">
                {STEPS.map((s, i) => (
                  <div className="bm-step bm-reveal" key={s.title}>
                    <span className="bm-step-num">{i + 1}</span>
                    <h3>{s.title}</h3>
                    <p>{s.desc}</p>
                  </div>
                ))}
              </div>
            </div>
          </section>

          {/* ===================== USE CASES ===================== */}
          <section className="bm-section" aria-labelledby="bm-usecases-title">
            <div className="bm-container">
              <div className="bm-section-head bm-reveal">
                <span className="bm-eyebrow">Made for every crew</span>
                <h2 className="bm-section-title" id="bm-usecases-title">
                  Perfect for the people you watch with
                </h2>
                <p className="bm-section-sub">
                  However you like to watch, BingeMates keeps everyone on the
                  same scene at the same second.
                </p>
              </div>
              <div className="bm-usecase-grid">
                {USE_CASES.map((u) => (
                  <article className="bm-card bm-reveal" key={u.title}>
                    <span className="bm-usecase-emoji" aria-hidden="true">
                      {u.emoji}
                    </span>
                    <h3>{u.title}</h3>
                    <p>{u.desc}</p>
                  </article>
                ))}
              </div>
            </div>
          </section>

          {/* ===================== THEMES ===================== */}
          <section className="bm-section" aria-labelledby="bm-themes-title">
            <div className="bm-container">
              <div className="bm-section-head bm-reveal">
                <span className="bm-eyebrow">Mood themes</span>
                <h2 className="bm-section-title" id="bm-themes-title">
                  Set the mood
                </h2>
                <p className="bm-section-sub">
                  Six hand-crafted themes the host can switch at any time to
                  match what you’re watching.
                </p>
              </div>
              <div className="bm-theme-row">
                {THEMES.map((t) => (
                  <div className="bm-theme-card bm-reveal" key={t.name}>
                    <div
                      className="bm-theme-swatch"
                      style={{
                        background: `linear-gradient(135deg, ${t.from} 0%, ${t.to} 100%)`,
                      }}
                    />
                    <div className="bm-theme-name">
                      <span>{t.name}</span>
                      {t.isDefault && (
                        <span className="bm-theme-tag">Default</span>
                      )}
                    </div>
                    <p className="bm-theme-mood">{t.mood}</p>
                  </div>
                ))}
              </div>
            </div>
          </section>

          {/* ===================== STATS ===================== */}
          <section className="bm-section">
            <div className="bm-container">
              <div className="bm-stats bm-reveal">
                <div>
                  <div className="bm-stat-num bm-gradient-text">18</div>
                  <div className="bm-stat-label">Platforms</div>
                </div>
                <div>
                  <div className="bm-stat-num bm-gradient-text">20</div>
                  <div className="bm-stat-label">Participants max</div>
                </div>
                <div>
                  <div className="bm-stat-num bm-gradient-text">100%</div>
                  <div className="bm-stat-label">Free</div>
                </div>
              </div>
            </div>
          </section>

          {/* ===================== SECURITY & PRIVACY ===================== */}
          <section
            className="bm-section"
            id="security"
            aria-labelledby="bm-security-title"
          >
            <div className="bm-container">
              <div className="bm-section-head bm-reveal">
                <span className="bm-eyebrow">Security &amp; privacy</span>
                <h2 className="bm-section-title" id="bm-security-title">
                  Private by design
                </h2>
                <p className="bm-section-sub">
                  Your watch parties stay yours. No accounts, no tracking, and
                  no data left behind once the credits roll.
                </p>
              </div>

              <div className="bm-feature-grid">
                {SECURITY.map((s) => (
                  <article className="bm-card bm-reveal" key={s.title}>
                    <span className="bm-feature-icon bm-feature-icon--shield">
                      {s.icon}
                    </span>
                    <h3>{s.title}</h3>
                    <p>{s.desc}</p>
                  </article>
                ))}
              </div>

              <div className="bm-privacy-panel bm-reveal">
                <div className="bm-privacy-panel-head">
                  <h3>What we never collect</h3>
                  <p>
                    BingeMates works without ever touching the data most apps
                    quietly hoover up.
                  </p>
                </div>
                <ul className="bm-nocollect-list">
                  {NEVER_COLLECT.map((item) => (
                    <li key={item}>
                      <span className="bm-nocollect-x" aria-hidden="true">
                        ✕
                      </span>
                      {item}
                    </li>
                  ))}
                </ul>
                <a className="bm-privacy-link" href="/bingemates/privacy-policy">
                  Read the full Privacy Policy →
                </a>
              </div>
            </div>
          </section>

          {/* ===================== FAQ ===================== */}
          <section className="bm-section" aria-labelledby="bm-faq-title">
            <div className="bm-container bm-container--narrow">
              <div className="bm-section-head bm-reveal">
                <span className="bm-eyebrow">FAQ</span>
                <h2 className="bm-section-title" id="bm-faq-title">
                  Questions, answered
                </h2>
              </div>
              <div className="bm-faq-list">
                {FAQS.map((item) => (
                  <details className="bm-faq-item bm-reveal" key={item.q}>
                    <summary>
                      <span>{item.q}</span>
                      <span className="bm-faq-icon" aria-hidden="true" />
                    </summary>
                    <div className="bm-faq-answer">{item.a}</div>
                  </details>
                ))}
              </div>
            </div>
          </section>

          {/* ===================== FINAL CTA ===================== */}
          <section className="bm-section">
            <div className="bm-container">
              <div className="bm-final bm-reveal">
                <h2>Ready to watch with your people?</h2>
                <p>
                  No account. No subscription. Just install and share a code.
                </p>
                <a
                  className="bm-btn bm-btn--primary bm-btn--lg"
                  href={CHROME_STORE_URL}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <ChromeIcon />
                  Add to Chrome — It’s Free
                </a>
                <p className="bm-final-note">
                  Available on Chrome, Brave, Edge, and Arc
                </p>
              </div>
            </div>
          </section>

          {/* ===================== FOOTER ===================== */}
          <footer className="bm-footer">
            <div className="bm-container">
              © {new Date().getFullYear()} BingeMates by Bogin Tech ·{' '}
              <a href="/bingemates/privacy-policy">Privacy Policy</a>
            </div>
          </footer>
        </div>
      </div>
    </Fragment>
  );
};

export default BingeMatesPage;
